import exxShop from '../../assets/images/exx_shop.svg';
import maFashion from '../../assets/images/ma_fashion.svg';
import suburban from '../../assets/images/suburban.svg';

export enum ShopTypes {
	ExxShop = 'ExxShop',
	MaFashion = 'MaFashion',
	Suburban = 'Suburban',
}

export const ShopLogo = {
	[ShopTypes.ExxShop]: exxShop,
	[ShopTypes.MaFashion]: maFashion,
	[ShopTypes.Suburban]: suburban,
};

export const ShopLogoHeight = {
	[ShopTypes.ExxShop]: 40,
	[ShopTypes.MaFashion]: 40,
	[ShopTypes.Suburban]: 30,
};
